// apps/admin/admin-main/src/pages/UberDeliveries/constants.ts

export const STATUS_COLORS: Record<string, string> = {
  pending: '#9e9e9e',
  created: '#9e9e9e',
  pickup_started: '#1976d2',
  pickup_imminent: '#1976d2',
  pickup_complete: '#3f51b5',
  dropoff_started: '#ed6c02',
  dropoff_imminent: '#ed6c02',
  dropoff_complete: '#2e7d32',
  delivered: '#2e7d32',
  canceled: '#d32f2f',
  returned: '#f57c00',
};

export const STATUS_LABELS: Record<string, string> = {
  pending: 'Pending',
  created: 'Created',
  pickup_started: 'Pickup En Route',
  pickup_imminent: 'Pickup Imminent',
  pickup_complete: 'Picked Up',
  dropoff_started: 'Dropoff En Route',
  dropoff_imminent: 'Dropoff Imminent',
  dropoff_complete: 'Delivered',
  delivered: 'Delivered',
  canceled: 'Canceled',
  returned: 'Returned',
};

export const TERMINAL_STATUSES = ['delivered', 'canceled', 'returned'];

export const STATUS_FIELD_MATRIX: Record<string, string[]> = {
  created: ['manifest_reference', 'dropoff_latitude', 'dropoff_longitude', 'pickup_notes', 'dropoff_notes', 'dropoff_seller_notes', 'pickup_ready_dt', 'pickup_deadline_dt', 'dropoff_ready_dt', 'dropoff_deadline_dt'],
  pickup_started: ['manifest_reference', 'dropoff_latitude', 'dropoff_longitude', 'pickup_notes', 'dropoff_notes', 'dropoff_seller_notes', 'pickup_ready_dt', 'pickup_deadline_dt', 'dropoff_ready_dt', 'dropoff_deadline_dt'],
  pickup_imminent: ['dropoff_notes', 'dropoff_seller_notes', 'pickup_ready_dt', 'pickup_deadline_dt', 'dropoff_ready_dt', 'dropoff_deadline_dt'],
  pickup_complete: ['dropoff_notes', 'dropoff_seller_notes'],
  dropoff_started: ['dropoff_notes', 'dropoff_seller_notes', 'tip_by_customer'],
  dropoff_imminent: ['tip_by_customer'],
  dropoff_complete: ['tip_by_customer'],
};

export const CANCEL_REASONS = [
  { value: 'out_of_items', label: 'Out of Items' },
  { value: 'cannot_deliver', label: 'Cannot Deliver' },
  { value: 'other', label: 'Other' },
];

export const AUTO_REFRESH_INTERVAL_MS = 30_000;
